import styles from "./styles.module.scss";

interface ProgressBarProps {
  progress: number;
  size?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  size,
}) => {
  return (
    <div className={styles.progressBar} style={{ width: `${progress}%`, height: size }}></div>
  );
};

export default ProgressBar;
